// extracted by mini-css-extract-plugin
module.exports = {"issuer":"Issuer_issuer__eoaSM","active":"Issuer_active__kSMul","issuer__headline":"Issuer_issuer__headline__3LMO8"};